import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { SystemListResponse } from "./types";

export class SystemListAPI extends BaseAPI<SystemListResponse> {
  protected route = ApiRoutes.system.list;
  protected method = RequestMethod.GET;
}
